<template>
  <base-link-list :list="links" :class="$style.wrap" />
</template>

<script>
import { mapGetters } from "vuex";
import BaseLinkList from "../components/BaseLinkList";

export default {
  name: "TheBar",
  components: { BaseLinkList },
  computed: {
    ...mapGetters(["businessLink", "vipLink"]),
    links() {
      return [
        {
          name: "business",
          ...this.businessLink
        },
        {
          name: "vip",
          ...this.vipLink
        },
        {
          name: "gameHome",
          ...this._anchor.gameHome
        }
      ];
    }
  }
};
</script>

<style module lang="less">
.wrap {
  margin-top: 1em;
  text-align: center;

  :global {
    .van-button {
      .size(2.44rem, auto);
      padding: 0;
      border: 0;
      font-size: @font-size-lg;
      line-height: inherit;

      &::before {
        display: block;
        position: static;
        top: auto;
        left: auto;
        height: 2.68rem;
        margin-bottom: 1em;
        background-color: transparent;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        transform: none;
        opacity: 1;
      }
    }

    .business .van-button::before {
      background-image: url("../images/bar_01.jpg");
    }

    .vip .van-button::before {
      background-image: url("../images/bar_02.jpg");
    }
    .gameHome .van-button::before {
      background-image: url("../images/bar_03.jpg");
    }
  }
}
</style>
